import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getActiveError } from '../store/error/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { useFooter } from './useFooter';
import { jsx as _jsx } from "react/jsx-runtime";
const Footer = styled.div.withConfig({
  displayName: "AppFooterComponent__Footer"
})(({
  theme
}) => Object.assign({}, theme.embedded && {
  gridArea: 'submain',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  fontSize: theme.typography['body-100'].fontSize,
  height: '80px',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: 'min(calc(100vw - 2 * 1.25rem), 28rem)'
}));
export const AppFooterComponent = () => {
  const footer = useFooter();
  const activeLoading = useSelector(getActiveLoading);
  const activeError = useSelector(getActiveError);
  return (!activeLoading || !activeError) && footer ?
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(Footer, {
    children: /*#__PURE__*/_jsx(footer.component, {})
  }) : null;
};